import * as yup from 'yup'

export const mediaTypeGroupValidationSchema = yup.object({
  title: yup
    .string()
    .trim()
    .max(50, 'The text is too long, maximum number of characters is 50')
    .required('This is a required field.'),
  description: yup
    .string()
    .trim()
    .max(255, 'The text is too long, maximum number of characters is 255')
    .required('This is a required field.'),
})
